import React, { useState } from 'react';
import { useAppDispatch } from '../../slices/types';
import { singlePointsOperation } from '../../slices/users/adminUsersSlice';

const AddFund: React.FC = () => {
    const dispatch = useAppDispatch();
    const [mobileNumber, setMobileNumber] = useState('');
    const [amount, setAmount] = useState<number | ''>('');
    const [comment, setComment] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!mobileNumber.trim() || !amount || Number(amount) <= 0) return;
        try {
            setSubmitting(true);
            await dispatch(
                singlePointsOperation({
                    mobile_number: mobileNumber.trim(),
                    amount: Number(amount),
                    action: 'add',
                    comment: comment.trim(),
                })
            ).unwrap();
            setMobileNumber('');
            setAmount('');
            setComment('');
        } catch (err) {
            console.error('Add fund error:', err);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="p-6">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border">
                <div className="px-6 py-4 border-b">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Add fund</h1>
                </div>
                <form onSubmit={handleSubmit} className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Mobile Number</label>
                            <input
                                type="text"
                                value={mobileNumber}
                                onChange={(e) => setMobileNumber(e.target.value)}
                                className="w-full px-3 py-2 border rounded-md"
                                placeholder="Enter User Mobile Number"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Amount</label>
                            <input
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value === '' ? '' : Number(e.target.value))}
                                className="w-full px-3 py-2 border rounded-md"
                                placeholder="Enter Amount"
                                min={1}
                                step={1}
                            />
                        </div>
                    </div>
                    <div className="mt-6">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Comment</label>
                        <textarea
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            className="w-full px-3 py-2 border rounded-md h-28 resize-y"
                            placeholder="Enter Comment"
                        />
                    </div>
                    <div className="mt-6">
                        <button
                            type="submit"
                            disabled={submitting || !mobileNumber.trim() || !amount || Number(amount) <= 0}
                            className="px-5 py-2 rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
                        >
                            Add Fund
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddFund;


